import { render, staticRenderFns } from "./cxContains.vue?vue&type=template&id=1c8cb186&scoped=true&"
import script from "./cxContains.vue?vue&type=script&lang=js&"
export * from "./cxContains.vue?vue&type=script&lang=js&"
import style0 from "./cxContains.vue?vue&type=style&index=0&id=1c8cb186&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8cb186",
  null
  
)

export default component.exports